import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';

const Coach = ({ edge }) => {
	console.log({edge});
	const { featuredImage, coach_information } = edge.node;
	const { jobInformation, links, nameInformation } = coach_information;

	return (
	<article className="coach">
		{featuredImage && 
				<img src={featuredImage.sourceUrl} alt={featuredImage.altText} className="coach-img" />
		}
		{nameInformation.last &&
			<h3>{nameInformation.first} {nameInformation.last}</h3>
		}
		{jobInformation &&
			<h4>{jobInformation.title}<br />
				<span><a href={jobInformation.companyUrl} target="_blank" rel="noopener noreferrer">{jobInformation.company}</a></span>
			</h4>
		}
		<ul className="links">
				{links.portfolioUrl && 
					<li><a href={links.portfolioUrl} target="_blank" title="View portfolio" rel="noopener noreferrer"><FontAwesomeIcon icon={faLink} /></a></li>
				}
				{links.twitterHandle && 
					<li><a href={`https://www.twitter.com/${links.twitterHandle}`} target="_blank" title={`View @${links.twitterHandle} on Twitter`} rel="noopener noreferrer"><FontAwesomeIcon icon={faTwitter} /></a></li>
				}
				{links.instagramHandle &&
					<li><a href={`https://www.instagram.com/${links.instagramHandle}`} target="_blank" title={`View @${links.instagramHandle} on Instagram`} rel="noopener noreferrer"><FontAwesomeIcon icon={faInstagram} /></a></li>
				}
		</ul>
	</article>
	);
};

export default Coach;
